import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import server from "api/server";
import { useLocation } from "react-router-dom";
import { getPageSection } from "api/pages";
import toast from "react-hot-toast";

const Index = () => {
  const { pathname } = useLocation();
  const slug = pathname.split("/")[2];

  const [data, setData] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onStart = async () => {
    const pageData = await getPageSection("home", slug);
    setData(pageData);
  };

  useEffect(() => {
    onStart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    reset({
      sectionTitle: data?.sectionTitle,
      description: data?.description,
    });
  }, [reset, data]);

  const onSubmit = async (data) => {
    try {
      data.title = slug;

      // eslint-disable-next-line no-unused-vars
      const savedResponse = await server().put(`/pages/home/sections/${slug}`, {
        section: data,
      });

      toast.success("تم حفظ التغيرات", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    } catch (error) {
      toast.error("يوجد خطأ فى حفظ البيانات ", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  };

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xxl={8} lg={12} md={12}>
                <Row>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>عنوان رئيسي</h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="عنوان رئيسي"
                          {...register("sectionTitle", { required: true })}
                        />
                      </div>
                      <p className="error-hint">
                        {errors?.sectionTitle && "يرجي ادخال  عنوان رئيسي"}
                      </p>
                    </div>
                  </Col>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>وصف رئيسي</h5>
                      <div>
                        <textarea
                          className="form-control form-outline"
                          placeholder="وصف رئيسي"
                          {...register("description", { required: true })}
                        ></textarea>
                      </div>
                      <p className="error-hint">
                        {errors?.description && "يرجي ادخال  وصف رئيسي"}
                      </p>
                    </div>
                  </Col>
                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        حفظ
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
